import { PageHeader } from 'antd'
import { useTranslation } from 'react-i18next'

const ImportUniformsPageHeader = () => {
  const { t } = useTranslation()
  return <PageHeader ghost={false} title={t('components.pages.uniforms.imports.pageHeader.title')} />
}

ImportUniformsPageHeader.displayName = 'ImportUniformsPageHeader'
export default ImportUniformsPageHeader
